import React from "react";
import { VideoCameraOutlined } from "@ant-design/icons";

export const ActionBtn = ({ status, noteEhrSubmitted, validApptFlag }) => {
  switch (status) {
    case "completed":
      return (
        <button 
          type="button"
          className="w-[100px] text-center bg-completed text-lightText px-2 py-0.5 rounded-full border border-grayHighlight hover:bg-opacity-80 hover:border-opacity-80 transition-all duration-200"
        >
          Completed
        </button>
      );
    case "active":
      return (
        <button 
          type="button"
          className="w-[100px] text-center bg-active text-lightText px-2 py-0.5 rounded-full border border-grayHighlight hover:bg-opacity-80 hover:border-opacity-80 transition-all duration-200"
        >
          Active
        </button>
      );
    case "in-progress":
      return (
        <button 
          type="button"
          className="w-[100px] text-center text-white bg-accent border border-white px-2 py-0.5 rounded-full hover:bg-opacity-90 hover:scale-105 transition-all duration-200"
        >
          In Progress
        </button>
      );
    default:
      const isStartDisabled = noteEhrSubmitted || validApptFlag === false;
      return (
        <button 
          metrics-label="Start Recording"
          type="button"
          disabled={isStartDisabled}
          className={`w-[100px] flex gap-x-2 justify-center items-center text-center px-2 py-0.5 rounded-full transition-all duration-200 ${
            isStartDisabled
              ? "bg-gray-400 text-gray-600 border border-gray-500 cursor-not-allowed opacity-60"
              : "text-white bg-accent border border-grayHighlight hover:bg-opacity-90 hover:scale-105 hover:shadow-md cursor-pointer"
          }`}
        >
          <VideoCameraOutlined />
          Start 
        </button>
      );
  }
};